import React  from 'react';
import { navigate } from "gatsby";
import Typography from '@material-ui/core/Typography';
import { Button } from '~/components/ui';
import styles from './styles';

export const NotFoundPage = () => {
    const classes = styles();
    const imgSrc = `${process.env.GATSBY_IMAGES}404.png`;
    const imgSrcWebP = `${process.env.GATSBY_IMAGES}404.webp`;
    return (
        <div className={classes.container}>
            <picture>
              <source type="image/webp" srcSet={imgSrcWebP}/>
              <source type="image/png" srcSet={imgSrc}/>
              <img src={imgSrc} className={classes.img} alt="404"/>
            </picture>

            <Typography className={classes.error}>
                ERROR
            </Typography>
            <Typography className={classes.text}>
                Sorry, the page you are looking for cannot be found.
            </Typography>
            <Button
                className={classes.btn}
                variant="primary"
                onClick={() => navigate('/')}
                title="Back to Home"
            />
        </div>
    )
}
